"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_METRICS = exports.IMAGE_PATH = exports.THUMBNAIL_PATH = void 0;
exports.THUMBNAIL_PATH = 'thumbnail.png';
exports.IMAGE_PATH = 'image.png';
exports.DEFAULT_METRICS = {
    triangles: 0,
    materials: 0,
    meshes: 0,
    bodies: 0,
    entities: 0,
    textures: 0
};
//# sourceMappingURL=constants.js.map